import { Node, mergeAttributes } from '@tiptap/core';
import katex from 'katex';
import 'katex/dist/katex.min.css';

export const Katex = Node.create({
  name: 'katex',

  group: 'inline',

  inline: true,

  selectable: false,

  atom: true,

  addAttributes() {
    return {
      latex: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-katex]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { 'data-katex': true })];
  },

  addNodeView() {
    return ({ node }) => {
      const wrapperDiv = document.createElement('div');
      wrapperDiv.setAttribute('contenteditable', 'false');
      const dom = document.createElement('math-inline');
      dom.className = 'math-node';
      const tex = node.attrs.latex;

      const render = document.createElement('span');
      render.className = 'math-render';

      try {
        katex.render(String(tex), render, {
          displayMode: false,
          globalGroup: true,
          output: 'html',
        });
      } catch (error) {
        render.innerHTML =
          "<span style='color: red;'>Invalid TeX expression.</span>";
      }

      dom.appendChild(render);
      wrapperDiv.appendChild(dom);

      return {
        dom: wrapperDiv,
      };
    };
  },
});
